import React, {useEffect, useState, Fragment, useRef} from 'react'
import {Card, Col, Container, Form, Row} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {  LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import {formatearNumero, isValidParam, validaNumeros} from '../../../../common/Formatos'
import {obtenerBancos, obtenerMediosPago, obtenerCalculoMontoCuota} from '../../../../store/actions/cierre-gestion-action'
import {useNavigate } from 'react-router-dom'
import CalendarioDeCuotas from './calendarioDeCuotas'

const DeclaracionPagoRecobro = ({
    formik, setPagoTotal, setPagoCuotas,
    medioPagoPie, setMedioPagoPie,
    montoPagoPieNoFormato, setMontoPagoPieNoFormato,
    setCuotasCalculadas,
    montoRendirPieNoFormato, setMontoRendirPieNoFormato,
    calcMode, setCalcMode,
    setCalendarDirty, calendarDirty
}) => {
    const fileRefComprobante = useRef();
    const [loading, setLoading]=useState(false)  
    const data_cierre_modal = useSelector((state) => state.cierreGestionReducer)
    const {cfg_form19, respuestaModalCierre, mediosDePago, bancos, calculoMontoCuota} = data_cierre_modal
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer)
    const {llaves} = data_recepciona
    const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
    const {montosInformados} = data_modal_cia

    const [isChecked, setIsChecked] = React.useState(false)
    const [fechaMin, setFechaMin]=useState('')
    const dispatch = useDispatch()
    const history =useNavigate()

    const [isPagoTotal, setIsPagoTotal] = useState(false)
    const [isPagoCuotas, setIsPagoCuotas] = useState(false)

    const calendarGeneradoRef = useRef(false)
    const [camposFaltantes, setCamposFaltantes] = useState([])

    const [medioPago, setMedioPago] = React.useState('')
    const [banco, setBanco] = React.useState('')
    const [nroChequeTrx, setNroChequeTrx] = React.useState('')
    const [fechaTransaccion, setFechaTransaccion] = React.useState('')
    const [covenioPagoCuota, setCovenioPagoCuota] = React.useState('')
    const [cntCuotas, setCntCuotas] = React.useState('')
    const [diaPago, setDiaPago] = React.useState('')
    const [fechaPrimerPago, setFechaPrimerPago] = React.useState('')
    const [fechaUltimoPago, setFechaUltimoPago] = React.useState('')

    //const [medioPagoPie, setMedioPagoPie] = React.useState('')
    const [fechaPagoPie, setFechaPagoPie] = React.useState('')
    const [montoPagoPie, setMontoPagoPie] = useState('')
    //const [montoPagoPieNoFormato, setMontoPagoPieNoFormato] = useState(0)
    const [montoRecobroCuotas, setMontoRecobroCuotas] = useState(0)
    const [codMonedaMI, setCodMonedaMI] = useState(0)
    const [montoRecobro, setMontoRecobro] = useState(0)

    const [montoRendirPie, setMontoRendirPie] = useState(0)

    const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoDirecto'))

    useEffect(()=>{
        if(respuestaModalCierre  && respuestaModalCierre.respuestaModalCierre["code"]===1) {
            setTimeout(()=> history('/area-trabajo-recupero-directo',{state:{queryState}}),2000)
        }
    },[respuestaModalCierre])

    useEffect(()=>{ 

       let monto = montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ? 
            formatearNumero(montosInformados.montosInformados[0]['MontoRecobro'], 
                !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001))
            : ''

        setMontoRecobroCuotas(montosInformados && montosInformados.montosInformados[0]['MontoRecobro']);
        setCodMonedaMI(montosInformados && montosInformados.montosInformados[0]['CodMoneda']);
        setMontoRecobro(montosInformados && montosInformados.montosInformados[0]['MontoRecobro']);

    },[montosInformados])

    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    const handleChange = (e) => {
        limpiar();
        if(e.target.value==="T"){
            setIsPagoTotal(true);
            setIsPagoCuotas(false);
            setIsChecked(!isChecked)
            setPagoTotal(1);
            setPagoCuotas(0);
        } else {
            setIsPagoTotal(false)
            setIsPagoCuotas(true);
            setPagoTotal(0);
            setPagoCuotas(1);
        }
        setLoading(true)
        let queryMedios = Buffer.from(JSON.stringify({concepto: 53})).toString('base64')
        let queryCalculo = Buffer.from(JSON.stringify({concepto: 219})).toString('base64')
        Promise.all([
            dispatch(obtenerMediosPago(queryMedios)),
            dispatch(obtenerCalculoMontoCuota(queryCalculo))
        ]).then(() => {
            setLoading(false)
            setCalcMode('219001')
        })
    }
    const limpiar = (e) => {
        setMedioPago('');
        setBanco('');
        setNroChequeTrx('');
        setFechaTransaccion('');
        setCovenioPagoCuota('');
        setCntCuotas('');
        setDiaPago('');
        setFechaPrimerPago('');
        setFechaUltimoPago('');
        setMedioPagoPie('');
        setFechaPagoPie('');
        setCalcMode('');
        setCalendarDirty(false);
        calendarGeneradoRef.current = false;
        setCamposFaltantes([]);
        setCuotasCalculadas('');
    }
    const calculaFechaUltimoPago = (value, from) => {

        let fechaInicial = null;
        let cntCuotas = null;

        if (from == 'C') {
            fechaInicial = formik.values['fechaPrimerPago'];
            cntCuotas = value;
        } else {
            fechaInicial = value;
            cntCuotas = formik.values['cntCuotas'];
        }

        if (fechaInicial !== null && typeof fechaInicial !== undefined) {
            const [anio, mes, dia] = fechaInicial ?. split('-')
            
            let mesFin = parseInt(mes) + parseInt(cntCuotas - 1);
        
            let fechaFin = null;
            if (mesFin > 12) {
                let mesFinMin12 = getMesFinPago(parseInt(mesFin) - 12);
                if (mesFinMin12 > 12) { 
                    fechaFin = [parseInt(anio) + 2, getMesFinPago(parseInt(mesFinMin12) - 12), dia];
                } else {
                    fechaFin = [parseInt(anio) + 1, getMesFinPago(parseInt(mesFinMin12)), dia];
                }                                
            } else {
                fechaFin = [parseInt(anio), getMesFinPago(mesFin), dia];
            }
            if (fechaFin != null && fechaFin != 'NaN-0NaN-') {
                setFechaUltimoPago(fechaFin.join('-'));
                setDiaPago(dia);
            }
        }             
    }
    function getMesFinPago(mesFin){
        if (mesFin > 9) {
            return mesFin;
        } else {
            return "0"+mesFin;
        }
    }

    useEffect(()=>{
        if (bancos && bancos.bancos.length == 1) {
            setBanco(bancos.bancos[0].id);
        } else {
            setBanco('');
        }
    },[bancos]);

    const handleCuotasGeneradas = (cuotas) => {
        setCuotasCalculadas(cuotas);
        if (cuotas && cuotas.length > 0) {
            calendarGeneradoRef.current = true;
        }
    };

    const handleOnCalendarGenerated = () => {
        setCalendarDirty(false);
    };

    return (
        <>
            <style type='text/css'>
                {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    .btn-carpeta {
      background-color: #F0AD3E;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }    
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color:  #F6897E;
      color: #FFFFFF;
    }
    `} </style>

        <LoadingComponent show={loading}/>
                <Card>
                    <Card.Header className='mt-0 mb-0' as='h6'
                        style={
                            {
                                backgroundColor: '#4F517A',
                                color: 'white'
                            }
                            }>
                        {cfg_form19 ? cfg_form19.cfg_form19['cierregestion-title-declaracion'] : ''}
                    </Card.Header>
                    <Container>
                        <Container> {
                            cfg_form19 ? (
                                <div>                            
                                    <Container>
                                        <Row>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{ fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-mdadeclara']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    {
                                                    montosInformados && montosInformados.montosInformados[0]['GlosaMoneda'] !== undefined && montosInformados.montosInformados[0]['GlosaMoneda'] !== null && montosInformados.montosInformados[0]['GlosaMoneda'] !== '' ? montosInformados.montosInformados[0]['GlosaMoneda'] : ''
                                                } </Form.Text>
                                            </Col>                                            
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                    }>
                                                    {cfg_form19.cfg_form19['cierregestion-mtorecobrodeclara']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    { montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobro']) ? 
                                                        formatearNumero(montosInformados.montosInformados[0]['MontoRecobro'], 
                                                            !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001))
                                                        : ''
                                                } </Form.Text>
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'></Form.Label>
                                                <Form.Check label={cfg_form19.cfg_form19['cierregestion-pagototaldeclara']} name="group2" type='radio' id='total' value='T'
                                                    checked={isPagoTotal}
                                                    onChange={
                                                        (e) => handleChange(e)
                                                    }
                                                />
                                                    
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'></Form.Label>
                                                <Form.Check label={cfg_form19.cfg_form19['cierregestion-pagocuotasdeclara']} name="group2" type='radio' id='cuotas' value='C'
                                                    checked={isPagoCuotas}
                                                    onChange={
                                                        (e) => handleChange(e)
                                                    }/>
                                            </Col>
                                        </Row>
                                    </Container>
                                    <hr style={{color: '#04005D', height: '2px', marginTop: '15px'}}></hr>                               
                                    {isPagoTotal ?(<Container>
                                        <Row>
                                            <Col md="3">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-cmb-mediopagodeclara']+" *"} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select  aria-label='Default select example'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setMedioPago(e.target.value)   
                                                            
                                                            let query2 = Buffer.from(JSON.stringify({idCaso: llaves && llaves['idCaso']})).toString('base64')
                                                            if (e.target.value == 53002 || e.target.value == 53003) {
                                                                query2 = Buffer.from(JSON.stringify({rutOrganizacion: llaves && llaves['idOrgCaso']})).toString('base64')
                                                            }
                                                            setLoading(true)
                                                            dispatch(obtenerBancos(query2)).then(() => {
                                                                setLoading(false)
                                                            })                                                 
                                                        }
                                                    }
                                                    name='medioPago'
                                                    value={(formik.values.medioPago = medioPago)}
                                                    error={formik.errors.medioPago}>
                                                    <option value={''}>Seleccione...</option>
                                                    {mediosDePago && mediosDePago.mediosDePago ?. map((c) => (
                                                        <option key={c.id} value={c.id}>
                                                            {c.nombre} 
                                                        </option>
                                                      ))
                                                    } 
                                                </Form.Select>
                                                {formik.errors.medioPago && formik.touched.medioPago &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.medioPago}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md="3">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-cmb-bancodeclara']+" *"}  
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select  aria-label='Default select example'
                                                    onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setBanco(e.target.value)
                                                        }
                                                    }
                                                    name='banco'
                                                    value={(formik.values.banco = banco)}
                                                    error={formik.errors.banco}>
                                                    <option value={''}>Seleccione...</option>
                                                    {bancos && bancos.bancos ?. map((c) => (
                                                        <option key={c.id} value={c.id}>
                                                            {c.nombre} 
                                                        </option>
                                                      ))
                                                    } 
                                                </Form.Select>
                                                {formik.errors.banco && formik.touched.banco &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.banco}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md="3">
                                                <Form.Label
                                                    className='mb-0 mt-3'
                                                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                >
                                                    {cfg_form19.cfg_form19['cierregestion-input-nrochequedeclara']} 
                                                </Form.Label>{' '}
                                                <br />
                                                <Form.Control
                                                    className='mt-2'
                                                    autoComplete='off'
                                                    value={(formik.values.nroChequeTrx = nroChequeTrx !== undefined && nroChequeTrx)}      
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setNroChequeTrx(e.target.value)
                                                    }}                                              
                                                    name='nroChequeTrx'
                                                    error={formik.errors.nroChequeTrx}
                                                ></Form.Control>
                                                {formik.errors.nroChequeTrx && formik.touched.nroChequeTrx &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.nroChequeTrx}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', }}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-fechatxtdeclara']+" *"} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control className='mb-0' type='date'
                                                    value={(formik.values.fechaTransaccion = fechaTransaccion)}
                                                    min={fechaMin && fechaMin}
                                                    max={hoy()}
                                                    name='fechaTransaccion'
                                                    onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setFechaTransaccion(e.target.value)
                                                        }
                                                    }
                                                    error={formik.errors.fechaTransaccion}
                                                >                                                    
                                                </Form.Control>
                                                {formik.errors.fechaTransaccion && formik.touched.fechaTransaccion &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.fechaTransaccion}
                                                    </Form.Text>
                                                }                                        
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-confirmarmonto'] + "*"} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control
                                                    className='mt-2'
                                                    aria-label='Default select example'
                                                    autoComplete='off'
                                                    onKeyDown={(e) => validaNumeros(e)}
                                                    onBlur={() => {
                                                        setMontoRendirPie(formatearNumero(montoRendirPie, !codMonedaMI == 30001))
                                                    }}
                                                    onFocus={() => setMontoRendirPie(montoRendirPieNoFormato)}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setMontoRendirPie(e.target.value)
                                                        setMontoRendirPieNoFormato(e.target.value)                                                                                                            
                                                    }}
                                                    name='montoRendirPie'
                                                    value={(formik.values.montoRendirPie = montoRendirPie)}
                                                    error={formik.errors.montoRendirPie}
                                                ></Form.Control> 
                                                {formik.errors.montoRendirPie ? (
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                        {formik.errors.montoRendirPie}
                                                    </Form.Text>
                                                ) : (
                                                    ''
                                                )}
                                            </Col>
                                            <Col md='8'>
                                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-subirdctocomprobante'] + " (para mas de un comprobante, adjuntarlos en un solo archivo) *"}
                                                </Form.Label>
                                                <Form.Group className="position-relative mb-2 mt-1">
                                                    <Form.Control ref={fileRefComprobante} type="file" name="fileComprobante"
                                                        onChange={event => { formik.setFieldValue("fileComprobante", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                                                        isInvalid={!!formik.errors.fileComprobante}
                                                        isValid={formik.touched.fileComprobante && !formik.errors.fileComprobante}
                                                    />
                                                    <Form.Text className="text-muted">Tamaño máximo del archivo: 5MB</Form.Text>
                                                    <Form.Control.Feedback type="invalid"> {formik.errors.fileComprobante} </Form.Control.Feedback>
                                                </Form.Group>                                                
                                            </Col>
                                        </Row>
                                    </Container> 
                                    ):('')}
                                    {isPagoCuotas ?(<Container>
                                        <Row>
                                            <Col md="2">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-cmb-mediopagopie']}
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select  aria-label='Default select example'
                                                    onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setMedioPagoPie(e.target.value)     
                                                            
                                                            let query2 = Buffer.from(JSON.stringify({idCaso: llaves && llaves['idCaso']})).toString('base64')
                                                            if (e.target.value == 53002 || e.target.value == 53003) {
                                                                query2 = Buffer.from(JSON.stringify({rutOrganizacion: llaves && llaves['idOrgCaso']})).toString('base64')
                                                            }
                                                            setLoading(true)
                                                            dispatch(obtenerBancos(query2)).then(() => {
                                                                setLoading(false)
                                                            })                                                                                                                                               
                                                        }
                                                    }
                                                    name='medioPagoPie'
                                                    value={(formik.values.medioPagoPie = medioPagoPie)}
                                                    error={formik.errors.medioPagoPie}>
                                                    <option value={''}>Seleccione...</option>
                                                    {mediosDePago && mediosDePago.mediosDePago ?. map((c) => (
                                                        <option key={c.id} value={c.id}>
                                                            {c.nombre} 
                                                        </option>
                                                      ))
                                                    } 
                                                </Form.Select>
                                                {formik.errors.medioPagoPie && formik.touched.medioPagoPie &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                        {formik.errors.medioPagoPie}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-cmb-bancodeclara']}  
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select  aria-label='Default select example'
                                                    onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setBanco(e.target.value)
                                                        }
                                                    }
                                                    name='banco'
                                                    value={(formik.values.banco = banco)}
                                                    error={formik.errors.banco}>
                                                    <option value={''}>Seleccione...</option>
                                                    {bancos && bancos.bancos ?. map((c) => (
                                                        <option key={c.id} value={c.id}>
                                                            {c.nombre} 
                                                        </option>
                                                      ))
                                                    } 
                                                </Form.Select>
                                                {formik.errors.banco && formik.touched.banco &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.banco}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label
                                                    className='mb-0 mt-3'
                                                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                >
                                                    {cfg_form19.cfg_form19['cierregestion-input-nrochequedeclara']} 
                                                </Form.Label>{' '}
                                                <br />
                                                <Form.Control
                                                    className='mt-2'
                                                    autoComplete='off'
                                                    value={(formik.values.nroChequeTrx = nroChequeTrx !== undefined && nroChequeTrx)}      
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setNroChequeTrx(e.target.value)
                                                    }}                                              
                                                    name='nroChequeTrx'
                                                    error={formik.errors.nroChequeTrx}
                                                ></Form.Control>
                                                {formik.errors.nroChequeTrx && formik.touched.nroChequeTrx &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.nroChequeTrx}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md='2'>
                                                <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                {cfg_form19.cfg_form19['cierregestion-input-montopagopie']}
                                                </Form.Label>{' '}
                                                <br />
                                                <Form.Control
                                                    className='mt-2'
                                                    aria-label='Default select example'
                                                    autoComplete='off'
                                                    onKeyDown={(e) => validaNumeros(e)}
                                                    onBlur={() => {
                                                        setMontoPagoPie(formatearNumero(montoPagoPie, !codMonedaMI == 30001))
                                                    }}
                                                    onFocus={() => setMontoPagoPie(montoPagoPieNoFormato)}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setMontoPagoPie(e.target.value)
                                                        setMontoPagoPieNoFormato(e.target.value)
                                                        let saldo = montoRecobro - e.target.value
                                                        setMontoRecobroCuotas(saldo)
                                                        if (calendarGeneradoRef.current) setCalendarDirty(true);
                                                    }}
                                                    name='montoPagoPie'
                                                    value={(formik.values.montoPagoPie = montoPagoPie)}
                                                    error={formik.errors.montoPagoPie}
                                                ></Form.Control> 
                                                {formik.errors.montoPagoPie ? (
                                                <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.montoPagoPie}
                                                </Form.Text>
                                                ) : (
                                                ''
                                                )}
                                            </Col>
                                            <Col md="2">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-fechapagopie']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control className='mb-0' type='date'
                                                    value={(formik.values.fechaPagoPie = fechaPagoPie)}
                                                    //min={hoy()}
                                                    //max={hoy()}
                                                    name='fechaPagoPie'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setFechaPagoPie(e.target.value)
                                                        }
                                                    }
                                                    error={formik.errors.fechaPagoPie}
                                                >                                                    
                                                </Form.Control>
                                                {formik.errors.fechaPagoPie && formik.touched.fechaPagoPie &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.fechaPagoPie}
                                                    </Form.Text>
                                                }                                        
                                            </Col>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3'
                                                    style={
                                                        {
                                                            fontWeight: 'bold',
                                                            fontSize: '14px'
                                                        }
                                                    }>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-recobrocuotas']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Text className="mt-3">
                                                    { formatearNumero(montoRecobroCuotas, !codMonedaMI == 30001) }
                                                </Form.Text>
                                                {camposFaltantes.includes('recobroCuotas') &&
                                                    <Form.Text style={{ color: 'red', display: 'block' }}>Requerido</Form.Text>
                                                }
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col md="2">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-cmb-mediopagodeclara'] + " (cuo)"}
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Select  aria-label='Default select example'
                                                    onChange={(e) => {
                                                            formik.handleChange(e)
                                                            setMedioPago(e.target.value)                                                                                                                                                   
                                                        }
                                                    }
                                                    name='medioPago'
                                                    value={(formik.values.medioPago = medioPago)}
                                                    error={formik.errors.medioPago}>
                                                    <option value={''}>Seleccione...</option>
                                                    {mediosDePago && mediosDePago.mediosDePago ?. map((c) => (
                                                        <option key={c.id} value={c.id}>
                                                            {c.nombre} 
                                                        </option>
                                                      ))
                                                    } 
                                                </Form.Select>
                                                {formik.errors.medioPago && formik.touched.medioPago &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                        {formik.errors.medioPago}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-coveniodeclara']} 
                                                </Form.Label>{' '}
                                                <br />
                                                <Form.Control
                                                    className='mt-2'
                                                    autoComplete='off'
                                                    value={(formik.values.covenioPagoCuota = covenioPagoCuota !== undefined && covenioPagoCuota)}      
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setCovenioPagoCuota(e.target.value)
                                                    }}                                              
                                                    name='covenioPagoCuota'
                                                    error={formik.errors.covenioPagoCuota}
                                                ></Form.Control>
                                                {formik.errors.covenioPagoCuota && formik.touched.covenioPagoCuota && 
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.covenioPagoCuota}
                                                    </Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label
                                                    className='mb-0 mt-3'
                                                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                >
                                                    {cfg_form19.cfg_form19['cierregestion-input-cntcuotasdeclara']+" *"} 
                                                </Form.Label>{' '}
                                                <br />
                                                <Form.Control
                                                    className='mt-2'
                                                    autoComplete='off'
                                                    value={(formik.values.cntCuotas = cntCuotas !== undefined && cntCuotas)}      
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setCntCuotas(e.target.value)
                                                        calculaFechaUltimoPago(e.target.value, 'C')
                                                        if (calendarGeneradoRef.current) setCalendarDirty(true);
                                                    }}
                                                    name='cntCuotas'
                                                    type="number"
                                                    error={formik.errors.cntCuotas}
                                                ></Form.Control>
                                                {formik.errors.cntCuotas && formik.touched.cntCuotas &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.cntCuotas}
                                                    </Form.Text>
                                                }
                                                {camposFaltantes.includes('cantidadDeCuotas') &&
                                                    <Form.Text style={{ color: 'red', display: 'block' }}>Requerido</Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-fechapripagodeclara']+" *"} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control className='mb-0' type='date'
                                                    value={(formik.values.fechaPrimerPago = fechaPrimerPago)}
                                                    min={fechaPagoPie}
                                                    //max={hoy()}
                                                    name='fechaPrimerPago'
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setFechaPrimerPago(e.target.value)
                                                        calculaFechaUltimoPago(e.target.value, 'F')
                                                        if (calendarGeneradoRef.current) setCalendarDirty(true);
                                                    }}
                                                    error={formik.errors.fechaPrimerPago}
                                                >                                                    
                                                </Form.Control>
                                                {formik.errors.fechaPrimerPago && formik.touched.fechaPrimerPago &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.fechaPrimerPago}
                                                    </Form.Text>
                                                }
                                                {camposFaltantes.includes('fechaPrimerPago') &&
                                                    <Form.Text style={{ color: 'red', display: 'block' }}>Requerido</Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-diapagodeclara']+" *"} 
                                                </Form.Label>{' '}
                                                <br />
                                                <Form.Control
                                                    className='mt-2'
                                                    //style={{ width: '100px' }}
                                                    autoComplete='off'
                                                    value={(formik.values.diaPago = diaPago !== undefined && diaPago)}      
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setDiaPago(e.target.value)
                                                    }}                                              
                                                    name='diaPago'
                                                    error={formik.errors.diaPago}
                                                    disabled
                                                ></Form.Control>
                                                {formik.errors.diaPago && formik.touched.diaPago &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.diaPago}
                                                    </Form.Text>
                                                }
                                                {camposFaltantes.includes('diaPago') &&
                                                    <Form.Text style={{ color: 'red', display: 'block' }}>Requerido</Form.Text>
                                                }
                                            </Col>
                                            <Col md="2">
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-fechaultpagodeclara']+" *"} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control className='mb-0' type='date'
                                                    value={(formik.values.fechaUltimoPago = fechaUltimoPago)}
                                                    min={hoy()}
                                                    //max={hoy()}
                                                    name='fechaUltimoPago'
                                                    onChange={
                                                        (e) => {
                                                            formik.handleChange(e)
                                                            setFechaUltimoPago(e.target.value)
                                                        }
                                                    }
                                                    disabled
                                                    error={formik.errors.fechaUltimoPago}
                                                >                                                    
                                                </Form.Control>
                                                {formik.errors.fechaUltimoPago && formik.touched.fechaUltimoPago &&
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                    {formik.errors.fechaUltimoPago}
                                                    </Form.Text>
                                                }                                        
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Form.Label className='mb-2 mt-3' style={{fontWeight: 'bold', fontSize: '14px'}}>
                                                    {cfg_form19.cfg_form19['cierregestion-input-confirmarmonto']} 
                                                </Form.Label>
                                                {' '}
                                                <br/>
                                                <Form.Control
                                                    className='mt-2'
                                                    aria-label='Default select example'
                                                    autoComplete='off'
                                                    onKeyDown={(e) => validaNumeros(e)}
                                                    onBlur={() => {
                                                        setMontoRendirPie(formatearNumero(montoRendirPie, !codMonedaMI == 30001))
                                                    }}
                                                    onFocus={() => setMontoRendirPie(montoRendirPieNoFormato)}
                                                    onChange={(e) => {
                                                        formik.handleChange(e)
                                                        setMontoRendirPie(e.target.value)
                                                        setMontoRendirPieNoFormato(e.target.value)                                                                                                            
                                                    }}
                                                    name='montoRendirPie'
                                                    value={(formik.values.montoRendirPie = montoRendirPie)}
                                                    error={formik.errors.montoRendirPie}
                                                ></Form.Control> 
                                                {formik.errors.montoRendirPie ? (
                                                    <Form.Text variant='danger' style={{ color: 'red' }}>
                                                        {formik.errors.montoRendirPie}
                                                    </Form.Text>
                                                ) : (
                                                    ''
                                                )}
                                            </Col>
                                            <Col md='8'>
                                                <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                                                    {cfg_form19.cfg_form19['cierregestion-lbl-subirdctocomprobante'] + " (para mas de un comprobante, adjuntarlos en un solo archivo) *"}
                                                </Form.Label>
                                                <Form.Group className="position-relative mb-2 mt-1">
                                                    <Form.Control ref={fileRefComprobante} type="file" name="fileComprobante"
                                                        onChange={event => { formik.setFieldValue("fileComprobante", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                                                        isInvalid={!!formik.errors.fileComprobante}
                                                        isValid={formik.touched.fileComprobante && !formik.errors.fileComprobante}
                                                    />
                                                    <Form.Text className="text-muted">Tamaño máximo del archivo: 5MB</Form.Text>
                                                    <Form.Control.Feedback type="invalid"> {formik.errors.fileComprobante} </Form.Control.Feedback>
                                                </Form.Group>                                                
                                            </Col>
                                        </Row>
                                    </Container> 
                                    ):('')}                                                 
                                    <hr style={{color: '#04005D', height: '0px', marginTop: '10px'}}></hr>    
                            </div>
                            ) : null
                        } 
                        </Container>
                    </Container>
                </Card>
                {isPagoCuotas ?(
                <Card>
                    <Container>
                        <CalendarioDeCuotas
                            recobroCuotas={montoRecobroCuotas}
                            cantidadDeCuotas={cntCuotas}
                            fechaPrimerPago={fechaPrimerPago}
                            diaPago={diaPago}
                            calcMode={calcMode}
                            setCalcMode={setCalcMode}
                            calculoMontoCuotaOptions={calculoMontoCuota?.calculoMontoCuota}
                            labelCalculo={cfg_form19?.cfg_form19['cierregestion-cmb-calculomontocuota']}
                            setCuotasCalculadas={handleCuotasGeneradas}
                            onCalendarGenerated={handleOnCalendarGenerated}
                            setCalendarDirty={setCalendarDirty}
                            calendarDirty={calendarDirty}
                            calendarGeneradoRef={calendarGeneradoRef}
                            setCamposFaltantes={setCamposFaltantes}
                        />
                    </Container>
                </Card>
                ):('')}            
        </>
    )
}

export default DeclaracionPagoRecobro
